import React, { useState } from "react";
import * as cl from "./Enroll.module.scss";
import { courseEnroll } from "../../../api/courseEnroll";
import { Preloader } from "../../../../../components/Preloader";

const Enroll = ({
  name,
  hasAccess,
  access,
  onEnroll,
  locked,
  onNoAccessClick,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  async function enroll() {
    if (!hasAccess) {
      onNoAccessClick(access);
      return;
    }

    setIsLoading(true);

    try {
      const responce = await courseEnroll(name);

      setIsLoading(false);
      onEnroll(responce);
    } catch (e) {}
  }

  if (hasAccess && !locked) return null;

  return (
    <div className={cl.enroll}>
      <button
        type="button"
        disabled={isLoading}
        className={cl.enroll__btn}
        onClick={enroll}
      >
        Get Started
      </button>
      {isLoading && <Preloader className={cl.enroll__spinner} />}
    </div>
  );
};

export default Enroll;
